import { type ComponentProps } from 'react'

import { type Icon } from '@factorialco/deprecated-design-system'

export enum KeyTagContent {
  Text,
  Icon,
}

interface KeyTagWithText {
  type: KeyTagContent.Text
  value: string
}

interface KeyTagWithIcon {
  type: KeyTagContent.Icon
  value: ComponentProps<typeof Icon.Tiny>['icon']
}

export type KeyTagType = KeyTagWithText | KeyTagWithIcon
